// Shared BroadcastChannel for cross-tab / cross-window logout synchronisation.
// BroadcastChannel messages are NOT delivered to the sender, so there is no
// risk of a logout loop when the originating tab posts to this channel.
export const logoutChannel = new BroadcastChannel('feemonk_logout');
